import React from 'react'

const Chores = () => {
  return (
    <div>
      Chores page here with a spinny wheel and everything!
    </div>
  )
}
export default Chores
